/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1AssetType } from '../models/V1AssetType';
import { HttpFile } from '../http/http';

export class V1UploadAssetMetadata {
    /**
    * The UUID of the Org receiving the upload.
    */
    'orgId': string;
    /**
    * The name of the file including extension.
    */
    'filename': string;
    /**
    * Set to true to make this the primary logo.
    */
    'isDefault'?: boolean;
    'assetType'?: V1AssetType;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "filename",
            "baseName": "filename",
            "type": "string",
            "format": ""
        },
        {
            "name": "isDefault",
            "baseName": "is_default",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "assetType",
            "baseName": "asset_type",
            "type": "V1AssetType",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1UploadAssetMetadata.attributeTypeMap;
    }

    public constructor() {
    }
}

